export default __webpack_public_path__ + "static/media/forebs.43e81828.svg";